module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyx"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © 2019 by Dan Roberts")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Published by Familius LLC, "), _c('a', {
    attrs: {
      "href": "http://www.familius.com",
      "target": "_blank"
    }
  }, [_vm._v("www.familius.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Familius books are available at special discounts for bulk purchases, whether for sales promotions or for family or corporate use. For more information, contact Familius Sales at 559-876-2170 or email "), _c('a', {
    attrs: {
      "href": "mailto:orders@familius.com"
    }
  }, [_vm._v("orders@familius.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Reproduction of this book in any manner, in whole or in part, without written permission of the publisher is prohibited.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("2018963781")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Print ISBN 9781641701235")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Ebook ISBN 9781641701723")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Printed in China")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Edited by Joseph Webb and Alison Strobel")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover design by David Miles")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Book design by David Miles and Derek George")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Images sourced from WikiCommons, Library of Congress, or licensed from Shutterstock.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First Edition ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0